{
    "dEC1I": {
        "position": {
            "x": 0,
            "y": 4,
            "z": 1
        },
        "key": "dEC1I",
        "tag": "wall",
        "hasCollision": true
    },
    "GGLx5": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "key": "GGLx5",
        "tag": "wall",
        "hasCollision": true
    },
    "1PTNZ": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "key": "1PTNZ",
        "tag": "wall",
        "hasCollision": true
    },
    "MVxQO": {
        "position": {
            "x": 10,
            "y": 7,
            "z": 1
        },
        "key": "MVxQO",
        "tag": "wall",
        "hasCollision": true
    },
    "eqUAm": {
        "position": {
            "x": 7,
            "y": 8,
            "z": 1
        },
        "key": "eqUAm",
        "tag": "wall",
        "hasCollision": true
    },
    "WV5oJ": {
        "position": {
            "x": 6,
            "y": 8,
            "z": 1
        },
        "key": "WV5oJ",
        "tag": "wall",
        "hasCollision": true
    },
    "HEzPp": {
        "position": {
            "x": 4,
            "y": 8,
            "z": 1
        },
        "key": "HEzPp",
        "tag": "wall",
        "hasCollision": true
    },
    "wMAm-": {
        "position": {
            "x": 1,
            "y": 6,
            "z": 1
        },
        "key": "wMAm-",
        "tag": "wall",
        "hasCollision": true
    },
    "Qpz9E": {
        "position": {
            "x": 0,
            "y": 5,
            "z": 1
        },
        "key": "Qpz9E",
        "tag": "wall",
        "hasCollision": true
    },
    "1U9tW": {
        "position": {
            "x": 2,
            "y": 7,
            "z": 1
        },
        "key": "1U9tW",
        "tag": "wall",
        "hasCollision": true
    },
    "JYLqO": {
        "position": {
            "x": 8,
            "y": 7,
            "z": 1
        },
        "key": "JYLqO",
        "tag": "wall",
        "hasCollision": true
    },
    "InXMn": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "InXMn",
        "tag": "wall",
        "hasCollision": true
    },
    "qJ_Fx": {
        "position": {
            "x": 11,
            "y": 5,
            "z": 1
        },
        "key": "qJ_Fx",
        "tag": "wall",
        "hasCollision": true
    },
    "2PIn4": {
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "key": "2PIn4",
        "tag": "wall",
        "hasCollision": true
    },
    "gKEWY": {
        "position": {
            "x": 10,
            "y": 6,
            "z": 1
        },
        "key": "gKEWY",
        "tag": "wall",
        "hasCollision": true
    },
    "dU_-1": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "key": "dU_-1",
        "tag": "wall",
        "hasCollision": true
    },
    "bKEZO": {
        "position": {
            "x": 5,
            "y": 8,
            "z": 1
        },
        "key": "bKEZO",
        "tag": "wall",
        "hasCollision": true
    },
    "F-o-W": {
        "position": {
            "x": 3,
            "y": 7,
            "z": 1
        },
        "key": "F-o-W",
        "tag": "wall",
        "hasCollision": true
    },
    "uFgDP": {
        "position": {
            "x": 4,
            "y": 4,
            "z": 1
        },
        "key": "uFgDP",
        "tag": "wall",
        "hasCollision": true
    },
    "zKEgg": {
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "key": "zKEgg",
        "tag": "wall",
        "hasCollision": true
    },
    "xtgor": {
        "key": "xtgor",
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "TdaTp": {
        "key": "TdaTp",
        "position": {
            "x": 8,
            "y": 5,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "sSt_L": {
        "position": {
            "x": 1,
            "y": 3,
            "z": 1
        },
        "key": "sSt_L",
        "tag": "wall",
        "hasCollision": true
    },
    "Za_x1": {
        "position": {
            "x": 2,
            "y": 3,
            "z": 1
        },
        "key": "Za_x1",
        "tag": "wall",
        "hasCollision": true
    },
    "3HcTN": {
        "position": {
            "x": 3,
            "y": 3,
            "z": 1
        },
        "key": "3HcTN",
        "tag": "wall",
        "hasCollision": true
    },
    "lxkPZ": {
        "position": {
            "x": 3,
            "y": 4,
            "z": 1
        },
        "key": "lxkPZ",
        "tag": "wall",
        "hasCollision": true
    },
    "_Geum": {
        "position": {
            "x": 10,
            "y": 3,
            "z": 1
        },
        "key": "_Geum",
        "tag": "wall",
        "hasCollision": true
    },
    "Nqvww": {
        "position": {
            "x": 11,
            "y": 4,
            "z": 1
        },
        "key": "Nqvww",
        "tag": "wall",
        "hasCollision": true
    },
    "z7dsp": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "z7dsp",
        "tag": "wall",
        "hasCollision": true
    },
    "HEBPk": {
        "key": "HEBPk",
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "AAqn7": {
        "key": "AAqn7",
        "position": {
            "x": 9,
            "y": 6,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "fj7GP": {
        "key": "fj7GP",
        "position": {
            "x": 10,
            "y": 5,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "page": {
        "key": "page",
        "position": {
            "x": 2,
            "y": 5,
            "z": 1
        }
    }
}